export default __webpack_public_path__ + "static/media/crossMark.7ff56198.svg";